import { filmInfo } from "@/mocks/movie";

export default function Hero() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0">
        <img
          src={filmInfo.heroImage}
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-foreground-950/30"></div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-8 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-10 lg:gap-16 items-center">
          <div className="animate-fade-up">
            <div className="flex flex-wrap items-center gap-2 mb-5">
              <span className="px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-semibold tracking-wide">
                2024 伦理剧情佳作
              </span>
              {filmInfo.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-background-50/15 text-background-100 text-xs border border-background-50/25"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading text-4xl md:text-6xl font-black text-background-50 leading-tight tracking-tight">
              {filmInfo.title}
              <span className="block mt-3 text-lg md:text-2xl font-medium text-accent-300">
                {filmInfo.subtitle}
              </span>
            </h1>

            <p className="mt-6 text-background-100/90 text-sm md:text-base leading-relaxed max-w-2xl">
              {filmInfo.logline}
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-background-100/80 text-sm">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line text-accent-300"></i>
                {filmInfo.year}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-accent-300"></i>
                {filmInfo.duration}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-map-pin-line text-accent-300"></i>
                {filmInfo.region}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-star-fill text-accent-400"></i>
                {filmInfo.rating}
                <span className="text-background-100/60">({filmInfo.ratingCount})</span>
              </span>
            </div>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => goTo("guide")}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看完整版
              </button>
              <button
                type="button"
                onClick={() => goTo("synopsis")}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-50/40 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-book-open-line text-lg"></i>
                先看剧情简介
              </button>
            </div>

            <p className="mt-5 text-xs text-background-100/60">{filmInfo.ageTip}</p>
          </div>

          <div className="animate-fade-up">
            <div className="relative mx-auto w-full max-w-sm">
              <div className="absolute -inset-3 rounded-lg border border-background-50/20"></div>
              <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden">
                <img
                  src={filmInfo.posterImage}
                  alt="《岳母的诱惑》影片海报"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-4 px-1 flex items-center justify-between text-xs text-background-100/70">
                <span>{filmInfo.genre}</span>
                <span className="px-2 py-0.5 rounded bg-background-50/15">
                  {filmInfo.ageTip.replace("建议 ", "")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}